import { QueryClient } from '@tanstack/react-query';
import { addWidgetQueries } from './queries/widget.queries.js';
import { addWidgetMutations } from './mutations/widget.mutations.js';
import { addShopQueries } from './queries/shop.queries.js';

export enum Queries {
    WIDGET_GET_ALL = 'getWidgetAll',
    WIDGET_GET_BY_ID = 'getWidgetById',
    SHOP_GET_INFO = 'getShopInfo',
}

export enum Mutations {
    WIDGET_CREATE = 'createWidget',
    WIDGET_UPDATE = 'updateWidget',
    WIDGET_DELETE = 'deleteWidget',
}

const defaultQueryFn = async ({ queryKey }: { queryKey: string[] }) => {
    return fetch(queryKey[0] as string);
};

export async function processResponse<T>(response: Response): Promise<T> {
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error?.message || 'An error occurred');
    }

    return response.json();
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            queryFn: defaultQueryFn as any,
            retry: false,
            staleTime: 1000 * 60 * 60 * 24,
        },
        mutations: {
            retry: false,
        },
    },
});

addWidgetMutations(queryClient);

addWidgetQueries(queryClient);
addShopQueries(queryClient);
